import React, { useMemo } from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';
import PageHeader from 'components/common/general/layouts/PageHeader';
import { HelpButton } from 'components/common/census/HelpButton';
import { useHistory } from 'react-router-dom';
import { BasicCensusFlowLayout } from 'components/common/census/BasicCensusFlowLayout';
import CensusEnrollmentPageStore, {
  CensusEnrollmentPageStoreContext,
  useCensusEnrollmentPageStore,
} from 'store/pages/enrollment/census-enrollment/pageStore';
import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';
import { PageWrapperStyled } from '../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = () => {
  const pageStore = useCensusEnrollmentPageStore();
  return <BasicCensusFlowLayout pageStore={pageStore} />;
};

// @deprecated  This is an old standalone page, the newer approach renders it as a part of the add-employees page.
const CensusEnrollmentPage: React.FC = () => {
  const history = useHistory();
  const { groupId, periodId } = useEnrollmentDomainParams();

  function redirectBack(): void {
    history.push(`/checklist/${periodId}`);
  }

  const pageStore = useMemo(() => new CensusEnrollmentPageStore({ groupId, enrollmentPeriodId: periodId }), []);

  return (
    <ProposalStatusLayout>
      <CensusEnrollmentPageStoreContext.Provider value={pageStore}>
        <PageWrapperStyled>
          <PageHeader title={CARD_DATA.CENSUS_IMPORT.title} onRedirect={redirectBack} subtitle={<HelpButton />} />
          <PageContent />
        </PageWrapperStyled>
      </CensusEnrollmentPageStoreContext.Provider>
    </ProposalStatusLayout>
  );
};

export default CensusEnrollmentPage;
